<template>
  <footer class="mobile-footer mobile" :class="{flex: $route.path.toLowerCase() === '/mobile/search'}">
    <div class="mobile-footer-content">
      <div style="margin-right:10px">©2012&nbsp;CKCEST&nbsp;ICP备案号:京ICP备14021735号-2</div>
      <div>
        <router-link :to="{path:'Us'}">关于我们</router-link>
      </div>
      <div class="clear"></div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "mFooter",
  data() {
    return {};
  },
  computed: {},

  mounted() {},
  methods: {},
  watch: {}
};
</script>

<style scoped>
.mobile-footer {
  color: #242526;
  height: 50px;
  background-color: #eaeaea;
  width: 100vw;
  display: flex;
}
.mobile-footer-content {
  margin: auto;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
.flex{
  position: fixed;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/mobile/common/Footer.vue